/**
 * Item overrides configuration
 * 
 * This file allows manual control over which items are shown or hidden
 * regardless of Divine-Pride API responses.
 * 
 * We will depend mostly on community feedback using the form in the page to report/suggest items.
 * 
 * blacklist: Items that should NEVER be shown, even if Divine-Pride says they're available
 * whitelist: Items that should ALWAYS be shown, even if Divine-Pride says they're not available
 */

export default {
  // Items that should never be shown (blacklist)
  blacklist: [
    // Add item IDs here
    // Example: 5000, 5001, 5002
  ],
  
  // Items that should always be shown (whitelist)
  whitelist: [
    // Add item IDs here
    // Example: 18000, 18001, 18002
  ]
};
